// App.js
import React, {useState} from "react";
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import {useAuth} from "./contexts/AuthContext";
import {auth} from "./firebase";
import {signOut} from "firebase/auth";

import Head from "./Head";
import Home from "./home/Home";
import NewSchool from "./school/NewSchool";
import Teacher from "./school/Teacher";
import SchoolAdminRegistration from "./school/SchoolAdminRegistration";
import SchoolAdminRegistrationSuccess from "./school/SchoolAdminRegistrationSuccess";
import SchoolRegistration from "./school/SchoolRegistration";
import RegistrationSuccess from "./school/RegistrationSuccess";
import SchoolList from "./school/SchoolList";
import SchoolHome from "./school/Home";
import AdminHome from "./school/AdminHome";
import SchoolLogin from "./school/Login";
import PersonalLogin from "./personal/Login";
import AdminLogin from "./admin/AdminLogin";
import PersonalHome from "./personal/Home";
import PersonalRegistration from "./personal/PersonalRegistration";
import PersonalRegistrationSuccess from "./personal/PersonalRegistrationSuccess";
import FestivalRegistration from "./personal/FestivalRegistration";
import FestivalRegistrationSuccess from "./personal/FestivalRegistrationSuccess";
import FestivalList from "./personal/FestivalList";
import FestivalScore from "./personal/FestivalScore";
import FestivalScoreBoard from "./personal/FestivalScoreBoard";

import MyDesk from "./personal/MyDesk";
import OrderCancel from "./personal/OrderCancel";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentApproval from "./pages/PaymentApproval";
import PayCancel from "./pages/PaymentCancel";
import PayFail from "./pages/PaymentFail";

import SchoolPayment from "./pages/SchoolPayment";
import SchoolPaymentSuccess from "./pages/SchoolPaymentSuccess";
import SchoolDesk from "./school/SchoolDesk";
import BillPDF from "./school/BillPDF";

import AdminDashboard from "./admin/AdminDashboard";

import logo from "./images/chocopy.svg";
import brand from "./images/logo-CHOCOPYthon-white-400.png";
import logostartc from "./images/logo-startc-white-400.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhone, faEnvelope, faHome, faSchool, faUserCircle} from "@fortawesome/free-solid-svg-icons";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  const [personal, setPersonal] = useState(false);
  const [school, setSchool] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [user, setUser] = useState(null);

  const {currentUser} = useAuth();

  const handleLogin = (user) => setUser(user);
  const handleLogout = async () => {
    try {
      await signOut(auth);
      alert("로그아웃 되었습니다.");
    } catch (error) {
      console.error("로그아웃 오류:", error);
    }
  };

  const handlePersonalLogin = (user) => {
    setUser(user);
    setPersonal(true);
  };
  const handlePersonalLogout = () => {
    setUser(null);
    setPersonal(false);
  };
  const handleSchoolLogin = (user) => {
    setUser(user);
    setSchool(true);
  };
  const handleSchoolLogout = () => {
    setUser(null);
    setSchool(false);
  };
  const handleAdminLogin = (user) => {
    setUser(user);
    setSchool(true);
  };
  const handleAdminLogout = () => {
    setUser(null);
    setSchool(false);
  };
  const PrivateRoute = ({children}) => currentUser ? children : <Navigate to="/personalLogin" />;
  const SchoolRoute = ({children}) => currentUser ? children : <Navigate to="/schoolLogin" />;
  const AdminRoute = ({children}) => currentUser ? children : <Navigate to="/adminLogin" />;

  return (
    <Router>
      <Head />

      <div className="App">
        <header className="App-header navbar-light navbar-sticky header-static">

          {/* Logo Nav START */}
          <nav className="navbar navbar-expand-xl">
            <div className="container-fluid px-3 px-xl-5">
              {/* Logo START */}
              <a href="/"><img src={logo} className="App-logo" alt="logo" /></a>
              <a className="navbar-brand px-2" href="/">
                <img src={brand} className="App-text-logo" alt="logo" />
              </a>
              {/* Logo END */}
              <a href="/personalHome" className="Home px-2"><FontAwesomeIcon icon={faHome} />개인</a>
              <a href="/newSchool" className="School px-2 text-success"><FontAwesomeIcon icon={faSchool} />학교</a>
            </div>


            {/* 로그인 상태 표시 */}
            {currentUser ? (
              <div className="ms-auto d-flex align-items-center">
                <button className="btn btn-secondary btn-sm px-2 py-1" onClick={handleLogout}>
                  <FontAwesomeIcon icon={faUserCircle} className="me-1" />{currentUser.displayName || currentUser.email} 로그아웃
                </button>
              </div>
            ) : (
              <p></p>
            )}
          </nav>
          {/* Logo Nav END */}

        </header>
        <main className="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/schoolHome" element={<SchoolHome />} />
            <Route path="/newSchool" element={<NewSchool />} />
            <Route path="/schoolReg" element={<SchoolRoute><SchoolRegistration /></SchoolRoute>} />
            <Route path="/success" element={<RegistrationSuccess />} />
            <Route path="/teacher" element={<Teacher />} />
            <Route path="/schoollist" element={<SchoolList />} />
            <Route path="/schoolLogin" element={<SchoolLogin onLogin={handleLogin} />} />
            <Route path="/schoolAdminRegistration" element={<SchoolAdminRegistration />} />
            <Route path="/schoolAdminRegistrationSuccess" element={<SchoolAdminRegistrationSuccess />} />
            <Route path="/adminLogin" element={<AdminLogin onLogin={handleAdminLogin} />} />
            <Route path="/personalLogin" element={<PersonalLogin onLogin={handlePersonalLogin} />} />
            <Route path="/personalRegistration" element={<PersonalRegistration />} />
            <Route path="/personalRegistrationSuccess" element={<PersonalRegistrationSuccess />} />
            <Route path="/festivalRegistration" element={<FestivalRegistration />} />
            <Route path="/festivalRegistrationSuccess" element={<FestivalRegistrationSuccess />} />
            <Route path="/festival-list" element={<FestivalList />} />
            <Route path="/festival-score" element={<FestivalScore />} />
            <Route path="/festival-scoreboard" element={<FestivalScoreBoard />} />
            <Route path="/mydesk" element={<PrivateRoute><MyDesk /></PrivateRoute>} />
            <Route path="/orderCancel" element={<OrderCancel />} />
            <Route path="/adminhome" element={user ? <AdminHome user={user} onLogout={handleLogout} /> : <Navigate to="/adminLogin" />} />
            <Route path="/personalHome" element={<PersonalHome />} />
            <Route path="/payment" element={<PrivateRoute><Payment /></PrivateRoute>} />
            <Route path="/paymentSuccess" element={<PaymentSuccess></PaymentSuccess>} />
            <Route path="/pay/approval" element={<PaymentApproval />} />
            <Route path="/pay/cancel" element={<PayCancel />} />
            <Route path="/pay/fail" element={<PayFail />} />
            <Route path="/dashboard" element={<AdminDashboard />} />

            <Route path="/schoolPayment" element={<SchoolRoute><SchoolPayment /></SchoolRoute>} />
            <Route path="/schoolPaymentSuccess" element={<SchoolPaymentSuccess></SchoolPaymentSuccess>} />
            <Route path="/schoolDesk" element={<SchoolRoute><SchoolDesk /></SchoolRoute>} />
            <Route path="/billPDF" element={<SchoolRoute><BillPDF /></SchoolRoute>} />

            <Route path="/adminLogin" element={<AdminLogin onLogin={handleAdminLogin} />} />

          </Routes>
        </main>
        <footer className="App-footer">
          <div>
            <img src={logostartc} className="Footer-logo" alt="startc logo" /><br></br>
            <p>
              <a href="tel:032-582-0100"><FontAwesomeIcon icon={faPhone} /> 032-582-0100</a> &nbsp; &nbsp;
              <a href="mailto:startc@kakao.com"><FontAwesomeIcon icon={faEnvelope} /> startc@kakao.com</a>
            </p>
          </div>

          {/* 사업자 및 법적 정보 */}
          <div className="text-gray-400 text-xs leading-6">
            <p><strong>상호명</strong> : 스타트씨주식회사</p>
            <p><strong>대표자</strong> : 박영진</p>
            <p><strong>주소</strong> : 인천광역시 서구 청라커낼로288번길 10, 더스페이스타워 1003호-1 (22762)</p>
            <p><strong>사업자등록번호</strong> : 156-81-03065 <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1568103065" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">[사업자정보확인]</a></p>
            <p><strong>통신판매업신고번호</strong> : 제2025-인천서구-1790호</p>
            <p><strong>개인정보관리책임자</strong> : 박영진</p>
            <p><strong>호스팅 제공자</strong> : 구글(Google LLC)</p>
            <p><strong>무통장 입금 계좌</strong> : IBK기업은행 955-048051-04-016(예금주: 스타트씨주식회사)</p>
            <p className="mb-1">
              <a href="/documents/TermsofService.pdf" className="hover:underline" target="_blank">이용약관</a> | <a href="/documents/Privacy.html" className="hover:underline" target="_blank">개인정보처리방침</a> | <a href="/documents/refund.html" className="hover:underline" target="_blank">환불정책</a>
            </p>
            <p className="Footer-copyright">
              copyright &copy; 2024 스타트씨주식회사. All rights reserved.
            </p>
          </div>

        </footer>
      </div>
    </Router>
  );
};

export default App;
